define('lq/services/Application/runtimeAnnotations',[
    "lq",
    "lq/validatorGateway",
    "lq/dispatcher",
], function (lq, validatorGateway, dispatcher) {
    "use strict";

    var runtimeAnnotations;

    var pressTimes = [];
    var delta = 500;
    var loggedIn = false;
    var $licquidApplication = $("#licquid-application");

    var blacklistedDropTypes = [
        "Action",
        "ContentRegion",
        "ListItem",
        "Stack",
        "ModalAction",
        "Rectangle",
        "DynamicGrid",
    ];

    function RuntimeAnnotations() {}

    RuntimeAnnotations.typeName = "RuntimeAnnotations";

    RuntimeAnnotations.prototype.initialize = function (app) {
        if (app) this.app = app;
        runtimeAnnotations = this;

        this.selectionActive = false;
        this.keyUpHandler = this.handleKeyUp.bind(this);
        this.hoverHandler = this.handleMousemove.bind(this);
        this.selectionHandler = this.handleDropSelection.bind(this);

        var self = this;
        // Check if the user is authorized
        dispatcher
            .dispatchToAbsoluteUrl(lq.getDesignerUrl("VerifyUser/VerifyAccess"))
            .then(function (data) {
                loggedIn = data;
            })
            .done(function () {
                $(document).on("keyup", self.keyUpHandler);
            }, function () {
                // Not logged in to the designer (a normal runtime visitor): no annotations.
                loggedIn = false;
            });
    };

    RuntimeAnnotations.prototype.getRootDrop = function () {
        // In case of SPA apps the rootDrop should be accessible on the app
        if (this.app) {
            return this.app.action;
        }
        return this.rootDrop;
    };

    RuntimeAnnotations.prototype.handleKeyUp = function (event) {
        if (event.key === "Shift") {
            var now = Date.now();
            pressTimes.push(now);

            if (pressTimes.length > 3) pressTimes.shift();

            if (pressTimes.length === 3 && pressTimes[2] - pressTimes[0] <= delta) {
                this.enterDropSelection();
                pressTimes.length = 0;
            }
        }

        if (event.key === "Escape" && this.selectionActive) {
            this.exitDropSelection();
        }
    };

    RuntimeAnnotations.prototype.enterDropSelection = function () {
        if (!loggedIn) {
            this.showLoginPopup();
            return;
        }

        var rootDrop = this.getRootDrop();
        rootDrop.activatePointAndClick();
        this.dropsWithPointAndClickActive = [rootDrop];

        this.createSelectionOverlay();
        this.toggleSelectionActive();
    };

    RuntimeAnnotations.prototype.handleMousemove = function (event) {
        var $element = $(event.target).closest(".drop-element");
        if (!$element.length) return;

        var currentlyHoveredDrop = $element.data("drop");
        if (!currentlyHoveredDrop) return;

        this.activatePointAndClickOnRoot(currentlyHoveredDrop);

        if (this.getDropIdOrDefault(this.hoveredDrop) !== currentlyHoveredDrop.data.id) {
            while (blacklistedDropTypes.includes(currentlyHoveredDrop.data.type)) {
                if (!currentlyHoveredDrop.parent) {
                    currentlyHoveredDrop = undefined;
                    break;
                }

                currentlyHoveredDrop = currentlyHoveredDrop.parent;
            }

            this.hoveredDrop = currentlyHoveredDrop;

            if (this.hoveredDrop) {
                this.hoveredDrop.$element.append(this.$hoveredDropBorder);
            } else {
                this.$hoveredDropBorder.remove();
            }
        }
    };

    RuntimeAnnotations.prototype.activatePointAndClickOnRoot = function (drop) {
        if (
            _.get(drop, ["rootDrop", "data", "type"], undefined) === "Action" &&
            !this.dropsWithPointAndClickActive.includes(drop.rootDrop)
        ) {
            drop.rootDrop.activatePointAndClick();
            this.dropsWithPointAndClickActive.push(drop.rootDrop);
        }
    };

    RuntimeAnnotations.prototype.handleDropSelection = function () {
        this.addAnnotation();
        this.exitDropSelection();
    };

    RuntimeAnnotations.prototype.exitDropSelection = function () {
        _.each(this.dropsWithPointAndClickActive, function (drop) {
            drop.deactivatePointAndClick();
        });

        this.toggleSelectionActive();
    };

    RuntimeAnnotations.prototype.toggleSelectionActive = function () {
        this.selectionActive = !this.selectionActive;
        this.$container.toggle(this.selectionActive);

        // Initalize or remove elements and handlers
        if (this.selectionActive) {
            this.hoveredDrop = undefined;
            // Some drops would not have correct borders by only using CSS, so this element will act as the border during selection.
            this.$hoveredDropBorder = $("<div>").addClass("hovered-drop-border");

            $licquidApplication.on("mousemove", this.hoverHandler);
            $licquidApplication.on("click", this.selectionHandler);
        } else {
            this.$hoveredDropBorder.remove();

            $licquidApplication.off("click", this.selectionHandler);
            $licquidApplication.off("mousemove", this.hoverHandler);
        }
    };

    RuntimeAnnotations.prototype.addAnnotation = function () {
        var targetDropId = this.getDropIdOrDefault(this.hoveredDrop);
        if (!targetDropId) return;

        var event = {
            type: "OPEN_ANNOTATION_CREATOR",
            targetDropId: targetDropId,
            rootOfTargetDrop: this.hoveredDrop.rootDrop,
        };

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEventToTop(event);
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEventToTop(event);
            });
        }
    };

    /* This is here so that in MPA apps the annotation editor opens on the topmost window */
    RuntimeAnnotations.prototype.editAnnotation = function (annotationId) {
        var event = {
            type: "OPEN_ANNOTATION_EDITOR",
            annotationId,
        };

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEventToTop(event);
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEventToTop(event);
            });
        }
    };

    RuntimeAnnotations.prototype.createSelectionOverlay = function () {
        if (this.$container && this.$container.length) return;

        var self = this;

        this.$container = $("<div>").addClass("runtime-drop-selector").appendTo($licquidApplication).hide();

        this.$buttonContainer = $("<div>")
            .addClass("runtime-annotation-buttons licquid-icon-view-annotations")
            // Mimic the hover functionality of the validator buttons
            .on("mouseenter", function () {
                var elem = $(this);
                self.addHovering = setTimeout(function () {
                    elem.addClass("hovering");
    
                    if (!self.removeHovering) {
                        self.removeHovering = setTimeout(function () {
                            elem.removeClass("hovering");
                            self.removeHovering = undefined;
                        }, 4000);
                    }
                }, 1000);
            })
            .on("mouseleave", function () {
                clearTimeout(self.addHovering);
            })
            .appendTo(this.$container);

        this.$closeButton = $("<div>")
            .addClass("close-button licquid-icon-close")
            .on("click", this.exitDropSelection.bind(this))
            .appendTo(this.$buttonContainer);

        this.$annotationBoardButton = $("<div>")
            .addClass("annotation-board-button licquid-icon-annotations")
            .attr("title", "Go to annotation board")
            .on("click", function () {
                window.location.href = lq.getPortalUrl("annotationBoard/");
            })
            .appendTo(this.$buttonContainer);

        this.$frame = $("<div>").addClass("runtime-drop-selector-frame").appendTo(this.$container);
    };

    RuntimeAnnotations.prototype.showLoginPopup = function () {
        var $loginPopupWrapper = $("<div>").addClass("login-popup-wrapper").appendTo($("body"));
        var $loginPopup = $("<div>").addClass("login-popup").appendTo($loginPopupWrapper);

        $("<h3>")
            .text("Licquid requires you to log in before you can view and edit annotations.")
            .appendTo($loginPopup);
        var $popupButtons = $("<div>").addClass("popup-buttons").appendTo($loginPopup);

        var self = this;
        $("<div>")
            .addClass("clickable btn")
            .text("Log in")
            .on("click", function () {
                self.login();
            })
            .appendTo($popupButtons);

        $("<div>")
            .addClass("clickable btn")
            .text("Cancel")
            .on("click", function () {
                $loginPopupWrapper.remove();
            })
            .appendTo($popupButtons);
    };

    RuntimeAnnotations.prototype.login = function () {
        window.licquidLoginCompleted = function () {
            window.location.reload();
            loggedIn = true;
        };

        window.open(lq.getDesignerUrl("Account/Validator"));
    };

    RuntimeAnnotations.prototype.getDropIdOrDefault = function (drop) {
        return _.get(drop, ["data", "id"], undefined);
    };

    window.runtimeAnnotations = {
        enterDropSelection: function () {
            // Wrapped in a setTimeout because the click event would propagate down from the validator panel
            // The event is not captured in the onClick the component so that's why it's easier to do this here
            setTimeout(function () {
                runtimeAnnotations.enterDropSelection();
            }, 0);
        },
        editAnnotation: function (annotationId, rootDrop) {
            runtimeAnnotations.editAnnotation(annotationId, rootDrop);
        },
    };

    return RuntimeAnnotations;
});

